import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['bool'] = function (block: Blockly.Block): any {
        const value = block.getFieldValue('BOOL') === 'TRUE' ? 'true' : 'false';
        return expr(value);
    };
}
